import {createReducer, on} from '@ngrx/store';
import * as errorHandlingActions from './error-handling.actions';

export const errorHandlingFeatureKey = 'errorHandling';

export interface ErrorState {
  errors: unknown[];
  uncaughtError: unknown;
}

export const initialErrorState: ErrorState = {
  errors: [],
  uncaughtError: undefined,
};

export const reducer = createReducer(
  initialErrorState,

  on(errorHandlingActions.uncaughtError, (state, {error}) => ({
    ...state,
    uncaughtError: error,
  })),
  on(errorHandlingActions.logError, (state, {error}) => {
    const errors = [...state.errors];
    errors.push(error);
    return {...state, errors};
  })
);

export const getUncaughtError = (state: ErrorState): unknown => state.uncaughtError;
export const getErrors = (state: ErrorState): unknown[] => state.errors;
